import styled from 'styled-components'
import { Input as OriginInput } from 'primsell-shared-layer/components'

export const BuyFormWrapper = styled.div`
  width: 100%;
  margin: 20px 0;
`

export const Input = styled(OriginInput)`
  margin-bottom: 24px;
`
